import { mapState } from 'vuex';
export default {
  name: 'MonitoringDisableDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    // 'pause' keeps the monitoring config & rules, 'delete' removes everything
    mode: {
      type: String,
      default: 'pause',
      validator: value => ['pause', 'delete'].includes(value)
    }
  },
  computed: {
    ...mapState('app', ['color']),
    isDelete() {
      return this.mode === 'delete';
    },
    dialogKey() {
      return this.isDelete ? 'stopDelete' : 'pause';
    }
  }
};